<template>
  <div class="card-container" v-if="url">
    <img v-lazy="url" alt="cover" class="card-img" :class="className" v-if="isLazy">
    <img :src="url" alt="cover" class="card-img" :class="className" v-if="!isLazy">
    <div class="card__tips" v-if="campNum">第{{campNum}}期</div>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    isLazy: {
      type: Boolean,
      default: true
    },
    className: {
      type: String,
      default: ''
    },
    campNum: {
      type: [Number, String],
      default: 0
    }
  }
};
</script>

<style scoped>
.card-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.card-img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

.card__tips {
  position: absolute;
  bottom: 2px;
  right: 2px;
  padding: 2px 4px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 2px;
  font-size: 10px;
  color: #191919;
}
</style>
